import React from 'react';
import { Dialog, Spinner } from '@economic/taco';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from '@lingui/macro';

import { useLocalization } from '~/app/shared/components/l10n/l10n';
import { PartialInvoiceDistributionInfoDto, PartialInvoiceDto } from '~/types/internal-api';
import { useQuery } from '~/app/shared/hooks/useQuery';
import { ErrorDialog } from '~/app/shared/components/modals/ErrorDialog';
import CreatePartialInvoice from './CreatePartialInvoice';
import { SalesDocument } from '../../types';
import ViewPartialInvoices from './ViewPartialInvoices';

export default function CreatePartialInvoiceDialog() {
    const location = useLocation();
    const navigate = useNavigate();
    const textsLoading = useLocalization(textIds);

    const salesDocumentId = location.state?.draftId;
    const openedFromOrder = location.pathname.includes('/orders');

    const {
        data: orderData,
        loading: orderQueryLoading,
        error: orderQueryError,
    } = useQuery<SalesDocument>(`sales/order/${salesDocumentId}`);

    const {
        data: partialInvoices,
        loading: partialInvoicesLoading,
        error: partialInvoicesError,
    } = useQuery<PartialInvoiceDto[]>(`sales/partial-invoice/${salesDocumentId}`);

    const {
        data: partialInvoiceDistributionTypeInfo,
        loading: partialInvoiceDistributionTypeInfoLoading,
        error: partrialInvoiceDistributionTypeInfoError,
    } = useQuery<PartialInvoiceDistributionInfoDto>(`sales/partial-invoice/distribution-type/${salesDocumentId}`);

    if (textsLoading || orderQueryLoading || partialInvoicesLoading || partialInvoiceDistributionTypeInfoLoading) {
        return <Spinner />;
    }
    if (
        orderQueryError !== undefined ||
        partialInvoicesError !== undefined ||
        partrialInvoiceDistributionTypeInfoError !== undefined
    ) {
        return <ErrorDialog onClose={close} />;
    }

    return (
        <Dialog size="sm" defaultOpen draggable onClose={() => navigate(location.pathname)}>
            <Dialog.Content aria-label={t`Partial invoice`}>
                {({ close }) => (
                    <>
                        {openedFromOrder ? (
                            <CreatePartialInvoice
                                close={close}
                                order={orderData}
                                partialInvoices={partialInvoices}
                                partialInvoiceDistributionTypeInfo={partialInvoiceDistributionTypeInfo}
                            />
                        ) : (
                            <ViewPartialInvoices close={close} order={orderData} partialInvoices={partialInvoices} />
                        )}
                    </>
                )}
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = ['ERROR_CODE_CreatePartialInvoiceProductNotFound'];
